<script setup lang="ts">
import { type PropType } from 'vue'
import { type LifeArticleDTO } from '@/composables/memorize/memorize'
import { isEmpty, isNotEmpty, minifyString } from '@/utils/util'
import { useRouter } from 'vue-router'
import { titleBar } from '@/composables/menu/title'
import { isSetRealName } from '@/composables/user/users'
const router = useRouter()

const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  serviceId: {
    type: String,
    default: ''
  },
  article: {
    type: Object as PropType<LifeArticleDTO | undefined>,
    default: () => undefined
  },
  canManage: {
    type: Boolean,
    required: true
  }
})
const emit = defineEmits(['showSetRealNameDialog'])
function handleCreate() {
  if (!isSetRealName.value) {
    emit('showSetRealNameDialog')
    return
  }
  router.push('/addOnesLife?serviceId=' + props.serviceId + '&name=' + titleBar.value?.life?.name.fullName)
}
</script>

<template>
  <div class="w-11/12 md:w-full" flex="~ row" bg-theme-light rounded-3 overflow-hidden p-4 bg-theme-gray>
    <div class="w-7/12" rounded-2 h-36 flex flex-col items-center justify-start pr-2>
      <div
        v-if="isNotEmpty(props.article?.content)"
        v-html="props.article?.content"
        class="life-img font-normal"
        line-clamp-5
        text-sm
        text-theme-gray
        leading-6.5
        @click="$router.push('/m/' + props.serviceId + '/life')" />
      <div v-if="isEmpty(props.article?.content)" h-full flex="~ row" items-center justify-center>
        <div text-theme-gray text-sm>{{ $t('m.slide_no_life') }}</div>
      </div>
    </div>
    <div flex="~ col" px-2>
      <h3 text-theme-main font-bold cursor-pointer @click="$router.push(`/m/${props.serviceId}/life`)">
        {{ $t('m.slide_ones_life', { name: minifyString(props.name, 12) }) }}
      </h3>
      <button v-if="props.canManage" btn-theme-outline text-xs my-0.5 mt-15 border-1px opacity-70 @click="handleCreate">
        {{ $t('m.slide_add_life') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
/* style */
/* 添加模糊过渡动画 */
.blur-layer {
  transition: filter 0.3s ease;
}

.life-img :deep(img) {
  @apply w-10 h-10 object-cover;
}

/* 优化模糊层性能 */
@media (prefers-reduced-motion: no-preference) {
  .blur-layer {
    will-change: filter;
  }
}

/* 移动端优化 */
@media (max-width: 768px) {
  .blur-layer {
    filter: blur(8px); /* 减小模糊强度 */
  }
}
</style>
